<section *ngIf="baseForm" class="sh-dialog__content">
    <p>{{'items.csv-export-dialog.select-export-profile' | translate}}</p>
    <div class="sh-form-group">
        <sh-form-multi-select
            [id]="'export-profile'"
            [control]="baseForm.controls.profile"
            [options]="profileOptions$ | async"
            [inOverflownContainer]="true"
            [isLoading]="!(profileOptions$ | async)"
            [loadingMsg]="'ui.loading' | translate"
        ></sh-form-multi-select>
    </div>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="prepare()" [disabled]="baseForm.invalid">{{config.data.ok}}</button>
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{config.data.cancel}}</button>
    </div>
</footer>
